var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticStyle:{"border-radius":"5px"},attrs:{"small":"","color":_vm.button.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":!_vm.show_more}},[_vm._v(_vm._s(_vm.alt_icon ? _vm.alt_icon : _vm.button.icon))]),_vm._v(" "+_vm._s(_vm.alt_label ? _vm.alt_label : _vm.button.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }